import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'store';

import { hotelResults } from 'actions/hotels';
import HotelsMap from 'components/HotelsMap';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';
import { HotelsResultResponse } from 'models/hotelsSearch';
import { City } from 'models/city';

interface Props {
  show: boolean;
  hotelsResult: HotelsResultResponse[];
  destinationPoint?: TravelHotelContentLocationRequest | City;
  onClick: (hotel: HotelsResultResponse) => void;
  onClose: () => void;
}

const HotelsMapContainer = ({ hotelsResult, destinationPoint, onClick, show, ...props }: Props) => {
  const { country, hotels, filters } = useSelector((state: RootState) => ({
    country: state.i18n.country,
    hotels: state.hotels,
    filters: state.hotels.filters,
  }));
  const dispatch = useDispatch();

  const handleSelect = (hotel: HotelsResultResponse) => {
    onClick(hotel);
  };

  useEffect(() => {
    const load = async () => {
      if (!show) return;
      if (hotels.isLoadingResults) return;
      if (!hotels.search) return;
      if (hotels.search.resultsCount <= hotels.search.results.length) return;
      if (hotels.isEnd) return;
      await dispatch(hotelResults(filters));
    };
    load();
  }, [dispatch, filters, hotels, show]);

  return (
    <HotelsMap
      {...props}
      show={show}
      currency={country.currency as string}
      hotelsResult={hotelsResult}
      destinationPoint={destinationPoint}
      onClick={handleSelect}
    />
  );
};

export default HotelsMapContainer;
